import React, { useState } from "react";
import Constants from "../constants/Constants";
import LazyLoad from "react-lazyload";
import ProgressiveImage from "react-progressive-image";
import { FiImage } from "react-icons/fi";
import { IoMdAlbums } from "react-icons/io";
import Lightbox from "react-image-lightbox";

const ModelArchivePhotoThumb = (props) => {
  const { video, file, isActive, join, site, actives, modelName } = props;
  const [open, setOpen] = useState();
  const [images, setImages] = useState([]);
  const [index, setIndex] = useState(0);
  const [loading, setLoading] = useState(false);
  const previewImage = `https://static.addfriends.com/vip/posters/${file.file_name.substring(
    0,
    file.file_name.lastIndexOf(".")
  )}.jpg`;
  const openLightBox = () => {
    if (loading) return;
    setLoading(true);
    fetch(`${Constants.API}get_images.php?v=${video.id}`, {
      credentials: "include",
    })
      .then((res) => res.json())
      .then((res) => {
        //handle
        if ("error" in res) {
          setLoading(false);
          return;
        }
        setImages(res);
        setOpen(true);
        setLoading(false);
      });
  };
  const handleNonActive = (e) => {
    if (!isActive && video.site_id !== "0") {
      if (modelName === "favorites") {
        if (actives.includes(video.site_id)) {
          openLightBox();
        } else {
          join(site);
          e.preventDefault();
        }
      } else {
        if (modelName === "library") {
          openLightBox();
        } else {
          join(site);
          e.preventDefault();
        }
      }
    } else {
      openLightBox();
    }
  };
  return (
    <div className="thumb">
      <div className="th image" onClick={handleNonActive}>
        <LazyLoad height={374} once>
          <ProgressiveImage
            src={previewImage}
            placeholder={previewImage.replace(".jpg", "-sm.jpg")}
          >
            {(src) => <img src={src} alt={`${video.title}`} />}
          </ProgressiveImage>
        </LazyLoad>
        {loading && (
          <div className="imageLoading">
            <div className="nk-spinner" />
          </div>
        )}
      </div>
      {video.archive_type === "album" && (
        <div className="image-item">
          <IoMdAlbums size={28} />
        </div>
      )}
      {video.archive_type === "photo" && (
        <div className="image-item">
          <FiImage size={28} />
        </div>
      )}
      {open && (
        <Lightbox
          mainSrc={images[index]}
          nextSrc={images[(index + 1) % images.length]}
          prevSrc={images[(index + images.length - 1) % images.length]}
          onCloseRequest={() => {
            setOpen(false);
            setImages([]);
          }}
          onMovePrevRequest={() =>
            setIndex((index + images.length - 1) % images.length)
          }
          onMoveNextRequest={() => setIndex((index + 1) % images.length)}
        />
      )}
    </div>
  );
};

export default ModelArchivePhotoThumb;
